<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <vc-layout :spacing="8">
      <vc-col :span="12" sm24>
        <example-title src="example-1.html" title="Default" />
        <vc-rating v-model="rating0" @input="onInput($event)" size="normal" />
        <div :class="['my-16']">
          <code>v-model: {{ rating0 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-2.html" title="Medium, custom color and items" />
        <vc-rating v-model="rating1" color-on="pink" :items="8" @input="onInput($event)" size="medium" />
        <div :class="['my-16']">
          <code>v-model: {{ rating1 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-3.html" title="Large, custom colors and items" />
        <vc-rating v-model="rating2" color-on="deep-purple" color-off="green" :items="7" @input="onInput($event)" size="large" />
        <div :class="['my-16']">
          <code>v-model: {{ rating2 }}</code>
        </div>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-4.html" title="Custom icon, label" url="http://icons.wemakesites.net/" />
        <vc-rating v-model="rating3" label="Give us a smile" icon="mdi-emoticon-happy" size="x-large" @input="onInput($event)" />
        <div :class="['my-16']">
          <code>v-model: {{ rating3 }}</code>
        </div>
      </vc-col>
      <vc-col :span="24" sm24>
        <example-title src="example-5.html" title="Readonly" url="http://icons.wemakesites.net/" />
        <vc-rating readonly v-model="rating4" label="Smiles we've got" :items="8" icon="mdi-emoticon-happy" @input="onInput($event)" />
        <div :class="['my-16']">
          <code>v-model: {{ rating4 }}</code>
        </div>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'RatingPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      rating0: 0,
      rating1: 5,
      rating2: 4,
      rating3: 2,
      rating4: 5
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    onInput (event) {
      console.log('vc-rate:input', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/rating.vue